<template>
  <div>
    <app-main style="height: 100%;" />
  </div>
</template>

<script>
  import { AppMain } from './components'
  export default {
    name: 'Mobile',
    components: {
      AppMain
    },
  }
</script>

<style>
</style>
